import regex from '../modules/regex-rules.js';
import { customValidate, customMessages, restrictInput } from '../modules/custom-validation.js';
import { setLoadingState, getAlertHtml, resetForm } from '../modules/form-helpers.js';
import { slideUp, slideDown } from '../modules/animations.js';
import { errorPlacement, highlight, unhighlight } from '../modules/form-validation.js';
import { toggleFields } from '../modules/form-helpers.js';
import { waitForRecaptcha } from '../modules/functions.js';

new toggleFields(document.getElementById('form-plus-2000'));

const $ = window.jQuery;

if (!$ || !$.fn || !$.fn.validate) {
	throw new Error('jQuery sau jQuery Validate nu sunt disponibile.');
}

window.dataLayer = window.dataLayer || [];

class Form {
	constructor({ formContainer, formName, formType, formCategory, recaptcha }) {
		this.recaptcha = recaptcha;

		if (!formContainer) {
			throw new Error('`formContainer` e null.');
		}

		if (!formContainer.dataset.fetchUrl) {
			throw new Error(`#${formContainer.id}: data-fetch-url e null.`);
		}

		if (!formName) {
			throw new Error('`formName` e null.');
		}

		if (!formType) {
			throw new Error('`formType` e null.');
		}

		if (!formCategory) {
			throw new Error('`formCategory` e null.');
		}

		this.form = formContainer;
		this.responseContainer = formContainer.querySelector('#response-message');

		if (!this.responseContainer) {
			throw new Error('#response-message e null.');
		}

		// Extragere info pachete
		try {
			this.packages = JSON.parse(formContainer.dataset.packages);
		} catch (err) {
			throw new Error(`Nu s-a putut parsa data-packages: ${err.message}`);
		}

		this.summaryContainer = formContainer.querySelector('#installments-summary');

		this.fetchError = false;
		this.errorType = '';
		this.autoCloseTimer = 10000;

		// dataLayer related
		this.formDescriptor = {
			form_name: formName,
			form_type: formType,
			form_category: formCategory,
			form_url: window.location.href.split('?')[0],
		};

		this.init();
		this.addListeners();
		this.validate();
	}

	init() {
		// Activare buton submit
		const submitBtn = this.form.querySelector('button[type="submit"]');
		submitBtn && (submitBtn.disabled = false);

		// Metode de validare custom
		$.validator.addMethod('alpha', customValidate.alpha);
		$.validator.addMethod('alphaNumeric', customValidate.alphaNumeric);
		$.validator.addMethod('phone', customValidate.phone);

		// Restrictionari inputuri
		restrictInput('#telefon', regex.digits);
		restrictInput('#nume', regex.lettersSpacesHyphens);
		restrictInput('#prenume', regex.lettersSpacesHyphens);
		restrictInput('#localitate', regex.lettersSpacesHyphensDigits);

		this.rules = {
			nume: {
				required: true,
				alpha: true,
				minlength: 3,
				maxlength: 50,
			},
			prenume: {
				required: true,
				alpha: true,
				minlength: 3,
				maxlength: 50,
			},
			telefon: {
				required: true,
				phone: true,
				minlength: 10,
				maxlength: 10,
			},
			email: {
				required: true,
				email: true,
			},
			judet: {
				required: true,
			},
			localitate: {
				required: true,
				alphaNumeric: true,
				minlength: 3,
			},
			echipament: {
				required: true,
			},
			acord_gdpr: {
				required: true,
			},
		};

		this.messages = {
			nume: {
				required: customMessages.required(),
				alpha: customMessages.alpha(),
				minlength: customMessages.minlength(),
				maxlength: customMessages.maxlength(),
			},
			prenume: {
				required: customMessages.required(),
				alpha: customMessages.alpha(),
				minlength: customMessages.minlength(),
				maxlength: customMessages.maxlength(),
			},
			telefon: {
				required: customMessages.required(),
				phone: customMessages.phone(),
				minlength: customMessages.minlength(null, 10, 'cifre'),
				maxlength: customMessages.maxlength(null, 10, 'cifre'),
			},
			email: {
				required: customMessages.required(),
				email: customMessages.email(),
			},
			judet: {
				required: customMessages.required(),
			},
			localitate: {
				required: customMessages.required(),
				alphaNumeric: customMessages.alphaNumeric(),
				minlength: customMessages.minlength(),
			},
			echipament: {
				required: customMessages.required(),
			},
			acord_gdpr: {
				required: customMessages.gdpr(),
			},
		};
	}

	addListeners() {
		if (!this.summaryContainer) {
			return;
		}

		const packageSelect = this.form.querySelector('#echipament');
		const installmentsSelect = this.summaryContainer.querySelector('#installments');

		if (!(packageSelect && installmentsSelect)) {
			return;
		}

		const selectedPackage = this.summaryContainer.querySelector('#selected-package');
		const packageComponents = this.summaryContainer.querySelector('#package-components');
		const priceContainer = this.summaryContainer.querySelector('#total-price');
		const downpaymentContainer = this.summaryContainer.querySelector('#downpayment');
		const installmentContainer = this.summaryContainer.querySelector('#installment');

		packageSelect.addEventListener('change', () => {
			const { id, label, prices } = this.packages.filter((p) => p.id === packageSelect.value)[0];

			if (!(id && prices)) {
				return;
			}

			selectedPackage && (selectedPackage.textContent = `Pachet ${id}`);

			const installments = Object.keys(prices);
			if (installments.length === 0) {
				return;
			}

			if (label && packageComponents) {
				const components = label.split('+').map((l) => l.trim());
				packageComponents.innerHTML = '<li style="list-style: none"><strong>Pachetul include:</strong></li>';
				components.forEach((component) => {
					packageComponents.innerHTML += `<li>${component}</li>`;
				});
			}

			const options = [];
			let innerHtml = '';
			installments.forEach((installment) => {
				options.push({
					value: installment,
					text: `${installment} rate`,
				});
			});

			options.forEach(({ value, text }, index) => {
				const selected = index === 0 ? 'selected' : '';
				innerHtml += `<option value="${value}" ${selected}>${text}</option>`;
			});

			installmentsSelect.innerHTML = innerHtml;
			installmentsSelect.dispatchEvent(new Event('change'));
		});

		installmentsSelect.addEventListener('change', () => {
			const { prices } = this.packages.filter((p) => p.id === packageSelect.value)[0];
			const { price, downpayment, monthly_rate: installment } = prices[installmentsSelect.value];

			priceContainer && (priceContainer.textContent = price);
			downpaymentContainer && (downpaymentContainer.textContent = downpayment);
			installmentContainer && (installmentContainer.textContent = installment);
		});
	}

	async handleSubmit(form, event) {
		event?.preventDefault();

		const selectedPackage = form.querySelector('#echipament')?.selectedOptions[0]?.textContent.trim() || '';

		const formData = new FormData(form);
		formData.append('action', 'send_plus_2000_lead');
		formData.append('package_name', selectedPackage);

		const recaptchaPassed = this.recaptcha.getResponse();

		// GTM TODO
		const formDetails = `Judet: ${formData.get('judet') || ''} | Pachet: ${formData.get('echipament') || ''}`;

		if (recaptchaPassed) {
			setLoadingState('loading');

			const url = new URL(form.dataset.fetchUrl);
			url.searchParams.set('action', 'send_plus_2000_lead');

			try {
				const response = await fetch(url, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(Object.fromEntries(formData)),
				});

				const { success, data } = await response.json();

				this.errorType = !success ? 'fetch' : '';

				if (success) {
					this.responseContainer.innerHTML = getAlertHtml('success', data.responseTitle || 'Datele au fost trimise cu succes', data.response, 'mt-4 auto-close');
					this.responseContainer.style.setProperty('--autoclose', `${this.autoCloseTimer}ms`);
					setTimeout(() => {
						slideUp(this.responseContainer);
						this.responseContainer.style.removeProperty('--autoclose');
						this.responseContainer.querySelector('#response-message-inner').classList.remove('auto-close');
					}, this.autoCloseTimer);

					// Datalayer
					window.dataLayer.push({
						...this.formDescriptor,
						event: 'form_submitted',
						form_details: formDetails,
						form_details2: selectedPackage,
						lead: 'Succes',
						phone_number: `+4${formData.get('telefon')}`,
						email: formData.get('email'),
					});

					resetForm(this.form);
				} else {
					this.responseContainer.innerHTML = getAlertHtml('danger', data.responseTitle || 'Am întâmpinat o eroare', data.response);

					window.dataLayer.push({
						...this.formDescriptor,
						event: 'form_error',
						error_field: data.field || data.reason || 'Server',
						error_message: data.response,
					});
				}
			} catch (err) {
				console.error('Fetch error:', err.message);
				this.errorType = 'fetch';
				this.responseContainer.innerHTML = getAlertHtml('danger');
			} finally {
				setLoadingState();
				this.recaptcha.reset();
				slideDown(this.responseContainer);
			}
		} else {
			this.errorType = 'recaptcha';
			this.responseContainer.innerHTML = getAlertHtml('danger', 'Bifează că nu ești robot.', 'Pentru a solicita oferta, e necesar să bifezi reCAPTCHA.');

			window.dataLayer.push({
				...this.formDescriptor,
				event: 'form_error',
				form_details: formDetails,
				lead: 'Captcha invalid',
				error_field: 'reCaptcha',
				error_message: 'reCaptcha nebifat',
			});

			slideDown(this.responseContainer);
		}
	}

	handleValidation(event, validator) {
		validator.errorList.forEach((error) => {
			let field = '';
			if (error.element.name === 'acord_gdpr') {
				field = 'Acord GDPR';
			} else if (error.element.type === 'radio') {
				field = error.element.closest('.nj-radio-group')?.querySelector('.nj-radio-group__legend')?.textContent.trim() || error.element.name;
			} else {
				field = error.element.closest('.nj-form-item')?.querySelector('.nj-form-item__label')?.textContent.trim() || error.element.name;
			}

			window.dataLayer.push({
				...this.formDescriptor,
				event: 'form_error',
				error_field: field,
				error_message: error.message,
			});
		});
	}

	handleErrors(validator) {
		if (validator.numberOfInvalids() > 0) {
			this.errorType = 'validation';
			this.responseContainer.innerHTML = getAlertHtml('danger', 'Câmpurile marcate cu roșu conțin erori', 'Te rugăm să verifici și să reîncerci.');
			slideDown(this.responseContainer);
		} else {
			if (this.errorType === 'validation') {
				this.errorType = '';
				slideUp(this.responseContainer);
			}
		}
		validator.defaultShowErrors();
	}

	validate() {
		const self = this;

		$(this.form).validate({
			focusInvalid: false,
			submitHandler: async function (form, event) {
				await self.handleSubmit(form, event);
			},
			invalidHandler: function (event, validator) {
				self.handleValidation(event, validator);
			},
			showErrors: function () {
				self.handleErrors(this);
			},
			rules: this.rules,
			messages: this.messages,
			errorPlacement,
			highlight,
			unhighlight,
			errorClass: 'text-danger line-height-1-3 t-centi e-form-error',
		});
	}
}

waitForRecaptcha({
	timeout: 2000,
})
	.then((recaptcha) => {
		recaptcha.ready(() => {
			new Form({
				formContainer: document.getElementById('form-plus-2000'),
				formName: 'P Plus',
				formType: 'lead',
				formCategory: 'Green',
				recaptcha,
			});
		});
	})
	.catch((err) => {
		console.error(err.message);
		const errorContainer = document.getElementById('form-plus-2000')?.querySelector('#response-message');
		if (errorContainer) {
			errorContainer.innerHTML = getAlertHtml('danger', 'reCAPTCHA indisponibil', 'Nu am putut încărca validarea reCAPTCHA. Te rugăm să reîncarci pagina.');
			slideDown(errorContainer);
		}
	});
